import { resolveHref } from 'next/dist/client/resolve-href'
import OriginalLink from 'next/link'
import Router from 'next/router'
import React, { useContext } from 'react'
import { AppUpdatedContext } from './UpdateMonitor'

export function Link({
  href,
  legacyBehavior,
  children,
  ...props
}: React.ComponentProps<typeof OriginalLink>) {
  const updated = useContext(AppUpdatedContext)

  if (updated) {
    const [, resolvedHref] = resolveHref(Router, href, true)

    const handleClick = function (e: React.MouseEvent) {
      if (!resolvedHref) return

      e.preventDefault()
      window.location.href = resolvedHref
    }

    if (legacyBehavior && React.isValidElement(children)) {
      children = React.cloneElement(children, {
        onClick: handleClick,
      } as any)
      return (
        <OriginalLink href={href} legacyBehavior={legacyBehavior} {...props}>
          {children}
        </OriginalLink>
      )
    }

    return (
      <OriginalLink
        href={href}
        legacyBehavior={legacyBehavior}
        {...props}
        onClick={handleClick}
      >
        {children}
      </OriginalLink>
    )
  }

  return (
    <OriginalLink href={href} legacyBehavior={legacyBehavior} {...props}>
      {children}
    </OriginalLink>
  )
}

export default Link
